import React from "react";

export const NoRegionSelected = () => (
    <div>No Region selected</div>
);